// @ts-nocheck
import { emptyCache } from "~/util/reviews-cache";
import { store } from "~/state/store";
import { watch, watchCurrentUser, watchNotifications } from "~/state/util";
import MyMapsLogin from "~/es6/mymaps.login";
import { node } from "~/util/dom";
import Content from "~/content";
import { PAGE_SUGGEST } from "./reviews/constants";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { Unsubscribe } from "redux";
import { ELoginState } from "~/state/user/interfaces";
import createSDSIcon from "~/ui/icon";
import { MYMAPS_STAR_EMPTY } from "~/ui/sds-compatible-icons";

interface IItem {
	title: string;
	component: any;
	name: string;
	url: string;
	svg: string;
	elm: any;
}

Mapy.MyMaps2 = class extends Content {
	_items: Array<IItem>;

	_activeItem: IItem;

	_activeItemName: string;

	_disableZoom: boolean;

	_logoutState: boolean;

	_contentChange: boolean;

	_lastContent: any;

	_storeUnsubscribeUser: Unsubscribe;

	_storeUnsubscribeNotifications: Unsubscribe;

	_loginPage: MyMapsLogin;

	constructor() {
		super();

		this._contentName = "mymaps";

		const components = {
			dashboard: Mapy.getComponent("dashboard"),
			reviews: Mapy.getComponent("reviews"),
			activities: Mapy.getComponent("activities"),
			places: Mapy.getComponent("places"),
		};
		const starIconDot = createSDSIcon({ symbol: MYMAPS_STAR_EMPTY });

		starIconDot.classList.add("hide");

		this._items = [{
			title: "dashboard",
			component: components.dashboard,
			name: "dashboard",
			url: "dashboard",
			svg: "star-line",
			elm: null,
		}, {
			title: "reviews",
			component: components.reviews,
			name: "reviews",
			url: "reviews",
			svg: "star-line",
			elm: null,
		}, {
			title: _("mymap.switcher.saved"),
			component: components.places,
			name: "places",
			url: "mista-trasy",
			svg: "star-line",
			elm: null,
		}, {
			title: _("mymap.switcher.activities"),
			component: components.activities,
			name: "activities",
			url: "aktivity",
			svg: "run",
			elm: null,
		}];
		this._activeItem = null;
		this._activeItemName = "";

		this._dom = {
			container: node("div", { id: "mymaps" }),
			holder: node("div"),
			button: {
				elm: node("button", { className: "icon mymap", type: "button" }),
				avatar: node("img"),
				avatarContainer: node("span", { className: "avatar" }),
				icon: starIconDot,
			},
		};
		this._dom.button.elm.setAttribute("data-log-text", "stateswitch-mymaps");
		this._lastContent = null;
		this._contentChange = false;
		this._disableZoom = false;
		this._logoutState = false;
		this._loginPage = new MyMapsLogin();

		const watchUser = watch(store.getState, "user", watchCurrentUser);
		const wtNotifications = watch(store.getState, "user", watchNotifications);

		this._storeUnsubscribeUser = store.subscribe(watchUser((newUser, oldUser) => {
			// pokud prepiname uzivatele, tak nulujeme aktivni komponentu na dashboard
			if ((oldUser.user.userPublicId && newUser.user.userPublicId !== oldUser.user.userPublicId) || newUser.user.state !== ELoginState.Green) {
				this._activeItemName = "dashboard";
			}

			this._buildButton(newUser.user);

			// login
			if (newUser.user.userPublicId && newUser.user.state === ELoginState.Green) {
				emptyCache();

				if (this.isActive()) {
					this._activateContent();
				}
			// logout
			} else {
				this._activeItemName = "dashboard";

				if (this.isActive()) {
					const likeData = this._activeItem ? this._activeItem.component.likeData : null;
					const state = this.getState();

					if (likeData) {
						state.likeData = likeData;
					}

					if (this._activeItem) {
						this._activeItem.component.state = state;
						this._activateContent(this._activeItem, true);
					}
				}
			}
		}));
		this._storeUnsubscribeNotifications = store.subscribe(wtNotifications(newUser => {
			starIconDot.classList[newUser.notifications.totalNew > 0 ? "remove" : "add"]("hide");
		}));

		const { user } = store.getState().user;

		this._build();
		this._buildButton(user);
	}

	destroy() {
		super.destroy();
		this._storeUnsubscribeUser();
		this._storeUnsubscribeNotifications();
		this._loginPage.destroy();
	}

	setState(state, activate = true) {
		if (state.cat) {
			if (state.cat === "review-suggestions") {
				const item = this._items[1];

				this._activeItemName = item.name;
				this._activeItem = item;
				item.component.state = {
					activePage: PAGE_SUGGEST,
				};

				if (activate && !this._lastContent) {
					this._activateContent(item);
				}
			} else if (state.cat !== "") {
				for (let index = 0; index < this._items.length; index++) {
					const item = this._items[index];

					if (item.url === state.cat) {
						this._activeItemName = item.name;
						this._activeItem = item;
						item.component.state = state;

						if (activate && !this._lastContent) {
							this._activateContent(item);
						}
					}
				}
			}
		}
	}

	getState() {
		if (this._activeItem) {
			const component = this._activeItem.component;
			const componentState = component.state;

			return {
				cat: this._activeItem.url,
				...componentState,
			};
		}

		return {};
	}

	activate(force, logout) {
		const isActive = this.isActive();

		super.activate();
		Scene.clearAllWasmContent();

		Mapy.getComponent("stateswitch").setState(this);

		if (isActive && force) {
			const curComponent = this._activeItem?.component;

			if (curComponent) {
				curComponent.deactivate();
				curComponent.state = {};
			}
		}

		const { user } = store.getState().user;

		if (Mapy.getComponent("history").isFromHistory()) {
			if (user.state !== ELoginState.Green) {
				Mapy.getComponent("layout").getScrollNode().classList.add("mymaps-login");
			}
		} else {
			this._logoutState = logout;
			this._activateContent(null, force);
			this._logoutState = false;

			if (!user && !logout) {
				Mapy.getComponent("login").open({
					analyticsData: {
						loginOrigin: "myMaps",
					},
					motivation: "none",
				});
			}

			this._logoutState = false;
		}

		Mapy.CML.state = {
			route: {
				showGeometries: false,
			},
		};

		return this;
	}

	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		super.deactivate();

		if (this._activeItem) {
			this._activeItem.component.deactivate();
		}

		this._build();

		this._lastContent = null;

		this.hide();
		Scene.clearAllWasmContent();

		return this;
	}

	show() {
		const { user } = store.getState().user;

		super.show();

		if (user.state !== ELoginState.Green) {
			Mapy.getComponent("layout").getScrollNode().classList.add("mymaps-login");
		}
	}

	hide() {
		super.hide();
		Mapy.getComponent("layout").getScrollNode().classList.remove("mymaps-login");
	}

	disableZoomToItems() {
		this._disableZoom = true;
	}

	getContainer() {
		return this._dom.container;
	}

	getButton() {
		return this._dom.button.elm;
	}

	activeComponent(component, force) {
		let item = this._items.filter(function filterItems(index) {
			return component === index.component;
		});

		if (this.isActive()) {
			this._activateContent(item[0], force);
		}

		item = this._items.filter(function filterItems(index) {
			return component === index.component;
		});

		if (item.length) {
			this._activeItemName = item[0].name;
		}
	}

	_build(force = false) {
		Mapy.Util.clear(this._dom.container);
		Mapy.getComponent("layout").getScrollNode().classList.remove("mymaps-login");

		const { user } = store.getState().user;

		if (user.state === ELoginState.Green || force) {
			this._dom.container.appendChild(this._dom.holder);
		} else {
			this._loginPage.rebuild(this._logoutState);

			this._dom.container.appendChild(this._loginPage.container);

			if (this.isActive()) {
				Mapy.getComponent("layout").getScrollNode().classList.add("mymaps-login");
			}
		}
	}

	_buildButton(user) {
		const login = user.userPublicId && user.state === ELoginState.Green;

		Mapy.Util.clear(this._dom.button.elm);

		this._dom.button.elm.classList[login ? "remove" : "add"]("nologin");

		if (user.state === "orange") {
			this._dom.button.elm.appendChild(Mapy.getComponent("profile").getAvatar());
		} else {
			this._dom.button.elm.appendChild(this._dom.button.icon);
		}

		const text = node("span");

		text.innerHTML = `${login ? `` : `<i>${_("mymap.login.button")}</i>`}${_("mymap.stateswitch")}`;
		this._dom.button.elm.appendChild(text);
	}

	_activateContent(content?, force = false) {
		let activeContent = null;
		const { user } = store.getState().user;

		if (user.state === ELoginState.Green || force) {
			this._build(true);

			let item = this._activeItemName || "dashboard";

			if (item === "photos") {
				item = "dashboard";
			}

			if (content) {
				this._activeItem = content;
				this._appendContentContainer(content.component);
				activeContent = content.component;
			} else if (item && Mapy.getComponent(item)) {
				this._activeItem = this._items.find(one => one.name === item);
				this._appendContentContainer(Mapy.getComponent(item));
				activeContent = Mapy.getComponent(item);
			} else {
				this._activeItem = this._items[0];
				this._appendContentContainer(this._items[0].component);
				activeContent = this._items[0].component;
			}

			this._contentChange = this._lastContent !== activeContent;
			activeContent.activate({
				disableZoom: this._disableZoom,
				contentChange: this._contentChange,
			});
			this._disableZoom = false;
			this._lastContent = activeContent;
		} else {
			this._items.forEach(function itemIterator(item) {
				item.component.deactivate();
			});
			this._build();
		}
	}

	_appendContentContainer(content) {
		this._items.forEach(function itemIterator(item) {
			const itemContent = item.component;

			itemContent.container.remove();
			itemContent !== content && itemContent.deactivate();
		});

		Mapy.Util.clear(this._dom.container);
		this._dom.container.appendChild(content.container);
	}
};
